export default "__VITE_ASSET__bMmluZHC__"